const driverShifts = {
  driverShifts: 'Turnos del conductor',

  driverLink: 'URL de la Aplicación de Horario del Conductor',

  filters: {
    areas: 'Zonas',
    drivers: 'Conductores',
    suppliers: 'Proveedores',
    vehicles: 'Vehículos',
    locations: 'Ubicaciones',
    airportLocations: 'Ubicaciones de Aeropuerto',
    attributes: 'Atributos',
  },

  calendarTypes: {
    daily: 'Diariamente',
    weekly: 'Semanal',
    monthly: 'Mensual',
  },

  driverfilter: {
    all: 'Todos los conductores',
    withShift: 'Conductores con Turnos',
    withoutShifts: 'Conductores sin turnos',
  },

  header: {
    create: 'Crear',
    createMulti: 'Crear varios',
    switchButton: {
      label: 'Ver',
      table: 'Tabla',
      calendar: 'Calendario',
    },
  },

  moreActions: {
    delete: 'Eliminar',
  },
  toast: {
    error: {
      sameDate: 'La Fecha de Inicio y la Fecha de Fin no pueden ser idénticas',
      badResponse: '[Turno de conductor] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  headerButtons: {
    createBtn: 'Crear',
    createMultiBtn: 'Crear varios turnos',
    deleteBtn: 'Eliminar',
  },

  table: {
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    headers: {
      name: 'Conductor',
      email: 'Conductor',
      address: 'Dirección',
      firstTripDistance: 'Distancia máxima del 1er viaje',
      addrLon: 'Lon',
      addrLat: 'Lat',
      at: 'Creado en',
      by: 'Creado por',
      areas: 'Zonas',
      locations: 'Ubicaciones',
      attributes: 'Atributos',
    },
    cells: {
      name: {
        vehicle: 'Vehículo',
      },
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    successToast: {
      message: '¡Se creó el turno del conductor de éxito!',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo crear el turno del conductor',
    },

    multi: {
      successToast: {
        message: '¡Se crearon turnos de conductores de éxito!',
      },
      errorToast: {
        message: '¡Error! Seleccione un día de la semana válido para el turno del conductor',
      },
    },
    modalAfter24: {
      header: 'Advertencia',
      body: 'Los turnos que ya han pasado las 24 horas no se pueden modificar',
    },
    modalBefore24: {
      header: 'Advertencia',
      body: 'Los cambios hechos dentro de las 24 horas de un turno existente deben ser confirmados. Confirme para continuar',
    },
  },

  update: {
    successToast: {
      message: '¡Cambio de conductor de éxito actualizado!',
    },
    errorToast: {
      message: '¡Ocurrió un error! No se pudo actualizar el turno del conductor',
    },
  },

  delete: {
    modalError: {
      header: 'Ocurrió un error',
      body: 'No se pudo actualizar',
    },
    modalSuccess: {
      header: 'Éxito',
      body: ' - Turnos eliminados correctamente',
    },
  },

  modalRemoveConfirm: {
    header: '¡Advertencia!',
    bodySingle: '¿Está seguro de que desea eliminar este turno?',
    bodyMultiple: '¿Está seguro de que desea eliminar estos turnos?',
    confirmBtn: 'Eliminar',
  },

  modalRemoveSingelConfirm: {
    header: 'Eliminar turno de conductor',
    body: 'Está a punto de eliminar 1 turno del conductor',
  },

  form: {
    header: {
      createDriverShift: {
        title: 'Crear',
      },

      createMultipleDriverShift: {
        title: 'Crear varios',
      },

      updateDriverShift: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
        delete: 'Eliminar',
      },
    },

    information: {
      details: {
        header: 'Detalles del conductor',
        fields: {
          driver: 'Conductor',
          vehicle: '(Vehículo: {{currentVehicle}})',
        },
      },
      shiftDetails: {
        header: 'Detalles de turno',
        overnightShiftNote: 'Nota: Este es un turno nocturno',
        fields: {
          fromDate: 'Início',
          toDate: 'Fin',
          address: 'Dirección',
          firstTripDistance: 'Distancia máxima del 1er viaje',
          attributes: 'Atributos',
          areas: 'Zonas',
          areasPriorityMode: {
            title: 'Modo',
            options: {
              allStops: 'Todas las paradas',
              firstPickDrop: 'Primera recogida / Última Entrega',
              legAOrigin: 'Origen del Tramo A',
            },
          },
          areasPriorityLevel: {
            title: 'Nivel',
            options: {
              low: 'Bajo',
              medium: 'Medio',
              high: 'Alto',
              strict: 'Estricto',
            },
          },
          suppliers: 'Proveedores',
          allowSharedRides: 'Permitir viajes compartidos',
        },
      },
      locationsSettings: {
        header: 'Configuraciones de Ubicaciones',
        fields: {
          locations: 'Ubicaciones',
          enableInBetweenRides: 'Habilitar Viajes Intermedios',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Se requieren conductores',
        drivers: '',
      },
      driver: {
        required: 'El conductor es obligatorio',
        driver: '',
      },
      start: {
        required: 'El inicio es obligatorio',
        start: '',
      },
      end: {
        required: 'El final es obligatorio',
        differentTimes: 'La hora de inicio y la hora de fin de un turno deben ser diferentes.',
        end: '',
      },
    },
    select: 'Seleccionar',
    buttons: {
      addBreak: '+ Add Break',
    },
  },

  formMulti: {
    header: {
      createMultiDriverShift: {
        title: 'Nuevos turnos de conductores múltiples',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Editar turnos de varios conductores',
      },
    },

    information: {
      details: {
        header: 'Detalles del conductor',
        fields: {
          drivers: 'Conductores',
        },
      },
      shiftDetails: {
        header: 'Detalles de turno',
        fields: {
          fromDate: 'De fecha',
          toDate: 'Hasta la fecha',
          weeksDays: 'Días de la semana',
          fromHour: 'De Hora',
          tohour: 'A Hora',
          breakStart: 'Inicio de descanso',
          breakEnd: 'Final del descanso',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Se requieren conductores',
      },
      driver: {
        required: 'El conductor es obligatorio',
      },
      start: {
        required: 'El inicio es obligatorio',
      },
      end: {
        required: 'El final es obligatorio',
      },
    },
    select: 'Seleccionar',
  },

  totalDriverShifts: 'Turnos totales del conductor',

  calendarTable: {
    filters: {
      areas: 'Zonas',
      drivers: 'Conductores',
      suppliers: 'Proveedores',
      attributes: 'Atributos',
    },

    daily: {
      actions: {
        delete: 'Eliminar',
      },
      noResults: 'No se encontraron resultados',
      noResultsSubHeader: 'No podemos encontrar ningún elemento que coincida con su búsqueda',
      selectAll: 'Seleccionar todo',
      selectAllPages: 'Todos los {{limit}} elementos de esta página están seleccionados. ',
      btnSelectAllResults: ' Seleccionar los {{totalDrivers}} elementos',
      btnunselectAllResults: 'Borrar selección',
      totalDrivers: 'Total de conductores: {{total}}',
      totalShifts: 'Total de turnos: {{total}}',
    },
    weekly: {
      actions: {
        delete: 'Eliminar',
      },
    },
    emptyCell: {
      dayOff: 'Día libre',
    },
    headers: {
      driverName: 'Nombre',
      monday: 'Lunes {{day}}',
      tuesday: 'Martes {{day}}',
      wednesday: 'Miércoles {{day}}',
      thursday: 'Jueves {{day}}',
      friday: 'Viernes {{day}}',
      saturday: 'Sábado {{day}}',
      sunday: 'Domingo {{day}}',
    },
  },
};

export default driverShifts;
